import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes, FaKeyboard } from 'react-icons/fa';
import './KeyboardShortcutsModal.css';

const KeyboardShortcutsModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  const shortcuts = [
    { key: '/', description: 'Focus search', category: 'Navigation' },
    { key: 'n', description: 'Create new post', category: 'Actions' },
    { key: 'Esc', description: 'Close modals/dialogs', category: 'General' },
    { key: '?', description: 'Show keyboard shortcuts', category: 'General' },
  ];

  if (!isOpen) return null;

  return createPortal(
    <AnimatePresence>
      <motion.div
        className="keyboard-shortcuts-overlay"
        onClick={onClose}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2 }}
      >
        <motion.div
          className="keyboard-shortcuts-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="keyboard-shortcuts-title"
          tabIndex={-1}
          initial={{ opacity: 0, scale: 0.95, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 20 }}
          transition={{ duration: 0.2, type: 'spring', stiffness: 300 }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="keyboard-shortcuts-header">
            <div className="keyboard-shortcuts-title-wrapper">
              <FaKeyboard className="keyboard-shortcuts-icon" />
              <h2 id="keyboard-shortcuts-title" className="keyboard-shortcuts-title">
                Keyboard Shortcuts
              </h2>
            </div>
            <button
              className="keyboard-shortcuts-close"
              onClick={onClose}
              aria-label="Close"
            >
              <FaTimes />
            </button>
          </div>

          <div className="keyboard-shortcuts-body">
            {shortcuts.map((shortcut, index) => (
              <div key={index} className="keyboard-shortcut-item">
                <div className="keyboard-shortcut-key">
                  <kbd>{shortcut.key}</kbd>
                </div>
                <div className="keyboard-shortcut-description">
                  {shortcut.description}
                </div>
              </div>
            ))}
          </div>

          <div className="keyboard-shortcuts-footer">
            <button className="btn btn-primary" onClick={onClose}>
              Got it
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>,
    document.body
  );
};

export default KeyboardShortcutsModal;

